import RdnaAvatarStacked from '@ringdna/common/src/components/RdnaAvatar/RdnaAvatarStacked'
import TargetingIcon from '@ringdna/cai/src/components/Moments/shared/TargetingIcon'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import IconHelper from '@ringdna/common/src/assets/icons/IconHelper'
import Pause from '@ringdna/common/src/assets/icons/player/Pause'
import Play from '@ringdna/common/src/assets/icons/player/Play'
import { AnnouncementTargetingType, ComplianceAnnouncement } from '../../types'
import styled from 'styled-components'
import RdnaText from '@ringdna/common/src/components/RdnaText'

type RowData = {
  original: ComplianceAnnouncement
}

export function getColumns() {
  return [
    {
      Header: 'Name',
      accessor: 'name',
      Cell: (data: { value: string }) => <CellText>{data.value}</CellText>
    },
    {
      Header: 'Description',
      accessor: 'description',
      Cell: (data: { value: string }) => <CellText>{data.value}</CellText>
    },
    {
      Header: 'Targeting',
      accessor: 'targetingType',
      disableFilters: true,
      width: 100,
      Cell: (data: { value: AnnouncementTargetingType | null; row: RowData }) => {
        const users = data.row.original.targetObjects.map(user => user.displayName)
        return data.value === AnnouncementTargetingType.INDIVIDUAL_USERS && users?.length ? (
          <RdnaAvatarStacked names={users} maxShown={3} tooltipPrefix={'Individual User: '} />
        ) : (
          <TargetingIcon type={data.value} labelType={'tooltip'} />
        )
      }
    },
    {
      Header: 'Listen',
      accessor: 'audioUrl',
      width: 30,
      disableSortBy: true,
      styles: {
        align: 'right'
      },
      Cell: function EnableCell(data: { value: string; row: RowData; rows: RowData[] }) {
        const audioEl = useRef<HTMLAudioElement>(null)
        const onPlayPauseClick = useCallback(() => {
          const isPlaying = data.row.original.isPlaying
          data.rows.filter(item => item.original.isPlaying).forEach(item => (item.original.isPlaying = false))
          data.row.original.isPlaying = !isPlaying
        }, [data])

        useEffect(() => {
          if (audioEl.current) {
            if (data.row.original.isPlaying) {
              audioEl.current.play()
            } else {
              audioEl.current.pause()
            }
          }
        }, [data.row.original.isPlaying])

        return (
          <>
            <audio ref={audioEl} src={data.value} id="sound">
              <track kind="captions" />
            </audio>
            <IconHelper
              icon={data.row.original.isPlaying ? Pause : Play}
              title={data.row.original.isPlaying ? 'Pause' : 'Play'}
              size={36}
              iconSize={24}
              onClick={onPlayPauseClick}
              testId={'play-pause-recording'}
            />
          </>
        )
      }
    },
    {
      Header: 'Actions',
      accessor: 'menu',
      disableSortBy: true,
      styles: { align: 'right' }
    }
  ]
}

export const CellText = styled(RdnaText)`
  color: black;
  padding: 0 5px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: initial !important;
  &.deleted {
    color: grey;
  }
`
